module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-damage"
  }, [_c('div', {
    staticClass: "damage-container"
  }, [_c('img', {
    staticClass: "car-outline",
    attrs: {
      "src": _vm.vehicleDamagePicture
    },
    on: {
      "click": _vm.addPin
    }
  }), _vm._l((_vm.pins), function(pin, index) {
    return _c('div', {
      staticClass: "component-pin",
      style: ({
        top: pin.top + 'px',
        left: pin.left + 'px'
      }),
      on: {
        "click": function($event) {
          return _vm.removePin(pin)
        }
      }
    }, [(pin.id) ? _c('span', {
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(pin.id))]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59d3e2d4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/VehicleDamage.vue
// module id = 2452
// module chunks = 1